import { selector } from 'recoil';
import { type ProductStatus } from '../types/onsaTypes';
import { allCoverablesOnsaAtom } from '../atoms/allCoverablesOnsaAtom';
import { allCoverablesAtom } from '../atoms/allCoverablesAtom';
import { updateProductStatusList } from '../../utils/coverablesUtil';

export const onsaProductStatusListSelector = selector<Record<string, ProductStatus[]>>({
    key: 'onsaProductStatusListSelector',
    get: ({ get }) => {
        const shoppingBasketCoverables = get(allCoverablesAtom);
        const onsaCoverables = get(allCoverablesOnsaAtom);
        const productStatusList = updateProductStatusList({}, shoppingBasketCoverables, true);
        return updateProductStatusList(productStatusList, onsaCoverables, false);
    }
});
